import Modal from '@sdk/components/ui/modal/Modal';
import HorizontalSeparator from '@sdk/components/ui/HorizontalSeparator';
import Row from '@sdk/components/ui/spacing/Row';
import { pgettext } from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { CreateTimesheetModalProps } from '@web/timesheets/CreateTimesheetModal/createTimesheetModal.types';
import {
  ModalWrapper,
  Content,
} from '@web/timesheets/CreateTimesheetModal/createTimesheetModal.styles';
import BodyPortal from '@web/components/BodyPortal';
import CreateTimesheetModalHeader from '@web/timesheets/CreateTimesheetModal/components/CreateTimesheetModalHeader/CreateTimesheetModalHeader';
import CreateTimesheetModalFooter from '@web/timesheets/CreateTimesheetModal/components/CreateTimesheetModalFooter/CreateTimesheetModalFooter';
import ShortSeparator from '@web/timesheets/CreateTimesheetModal/components/ShortSeparator/ShortSeparator';
import EmployeeRow from '@web/timesheets/CreateTimesheetModal/components/rows/EmployeeRow/EmployeeRow';
import LocationRow from '@web/timesheets/CreateTimesheetModal/components/rows/LocationRow/LocationRow';
import PositionRow from '@web/timesheets/CreateTimesheetModal/components/rows/PositionRow/PositionRow';
import DateRow from '@web/timesheets/CreateTimesheetModal/components/rows/DateRow/DateRow';
import TimeClockSections from '@web/timesheets/CreateTimesheetModal/components/TimeClockSections/TimeClockSections';
import AddEntryButton from '@web/timesheets/CreateTimesheetModal/components/buttons/AddEntryButton';
import DurationRow from '@web/timesheets/CreateTimesheetModal/components/rows/DurationRow/DurationRow';
import { useCreateTimesheetModal } from '@web/timesheets/CreateTimesheetModal/createTimesheetModal.hooks';

const CreateTimesheetModal = ({
  isVisible,
  close,
  onCreateTimesheet,
}: CreateTimesheetModalProps) => {
  const {
    modalConfig,
    onModalClose,
    fields,
    onEmployeeChange,
    locationOptions,
    positionOptions,
    dynamicLists,
    addEntry,
    canSubmit,
    onSubmit,
    submitErrors,
    setSubmitErrors,
  } = useCreateTimesheetModal({ close, onCreateTimesheet });

  return (
    <BodyPortal>
      <Modal isVisible={isVisible} fixed config={modalConfig} zIndex={1045} flexCentered={false}>
        <ModalWrapper>
          <CreateTimesheetModalHeader onClose={onModalClose} />
          <Content>
            <EmployeeRow employeeField={fields.employee} onChange={onEmployeeChange} />
            <LocationRow locationField={fields.location} options={locationOptions} />
            <PositionRow positionField={fields.position} options={positionOptions} />
            <ShortSeparator />
            <DateRow dateField={fields.date} />
            <TimeClockSections
              timeClockFields={dynamicLists.timeClock.fields}
              submitErrors={submitErrors}
              setSubmitErrors={setSubmitErrors}
            />
            <DurationRow
              timeClockEntries={dynamicLists.timeClock.value}
              entriesDate={fields.date.value}
            />
            <Row mTop={10} mBottom={10}>
              <HorizontalSeparator themeColor={ThemeColorType.separatorOnGray} />
            </Row>
            <Row mTop={10} justifyContent="flex-end">
              <AddEntryButton
                label={pgettext(
                  'Adding new time clock (clock in - clock out) section when creating timesheet',
                  'Add entry'
                )}
                onClick={addEntry}
              />
            </Row>
          </Content>
          <CreateTimesheetModalFooter
            onSave={onSubmit}
            onClose={onModalClose}
            canSubmit={canSubmit}
          />
        </ModalWrapper>
      </Modal>
    </BodyPortal>
  );
};

export default CreateTimesheetModal;
